import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './TaskAuthor.module.css';
import { useTaskAuthor } from './lib/hooks/useTaskAuthor';
import { Icon } from 'shared/ui';
import { useTranslation } from 'react-i18next';

interface TaskAuthorProps {
    taskId: string;
    classes?: string;
}

export const TaskAuthor = memo(({ taskId, classes }: TaskAuthorProps) => {
    const { authorInfo } = useTaskAuthor(taskId);
    const { t } = useTranslation();

    return (
        <div className={classNames(cls.TaskAuthor, [classes])}>
            <span className={cls.IconSpan} title={t('Features.TaskAuthor.AttributeTitle.text')}>
                <Icon iconName={'taskAuthor'} />
            </span>
            <span>{authorInfo?.name}</span>
        </div>
    );
});
